<ng-container>
    <!--  <h1 *ngIf="showText">{{'WELCOME_BACK_TITLE' | translate}}</h1>-->
    <!--  <h2>{{username}}</h2>-->

    <!--  Custom-->
    <h1 role="heading" class="custom-login-info">Einloggen</h1>

    <div style="position: relative; overflow: hidden;">
        <a class="custom-email-change-link" tabindex="0" (keydown.enter)="changeEmail()" (click)="changeEmail()">ÄNDERN <i class="arrow right"></i></a>
        <app-input [option]="inputOption.emailCustom" class="custom-email" *ngIf="username"></app-input>
    </div>

    <app-authenticate *ngIf="isInitiated && showInputField" [options]='verifyInputOption'
                      (notificationStatus)="checkNotificationStatus($event)"></app-authenticate>

    <ng-template #multipleDeviceList>
        <mat-dialog-content>
            <table mat-table [dataSource]="mediumList" class="mat-elevation-z8">

                <!-- Medium ID Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> Medium Id </th>
                    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>

                <!-- Medium Name Column -->
                <ng-container matColumnDef="key_name">
                    <th mat-header-cell *matHeaderCellDef> Medium Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.key_name}} </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="notification">
                    <th mat-header-cell *matHeaderCellDef> Send Notification </th>
                    <td class="text-center cursor-pointer" mat-cell *matCellDef="let element" (click)="selectDevice(element)">
                        <mat-icon>send_to_mobile</mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-dialog-content>
    </ng-template>

    <p *ngIf="showText" [ngClass]="{'display_none': allowedMFA.length<=1}" style="display: none">
        {{'LOGIN.AUTHENTICATION.HOW_DO_YOU_WANT_TO_AUTHENTICATE' | translate}}</p>
    <p *ngIf="!showText">{{'PASSWORD_FORGOT_INIT.CHOOSE_ANOTHER_METHOD' | translate}}</p>

    <ul class="mfa-icon-list" [ngClass]="{'display_none': allowedMFA.length<=1}" style="display: none">
        <li #li [ngClass]="item" *ngFor="let item of allowedMFA"
            (click)="_initiateAuthentication(item, $event, multipleDeviceList)">
            <div fxLayoutAlign="center center" fxLayout="column">
        <span [class.active]="isInitiated && item === 'password'" id="login"
              class="mfa-method-icon {{'cidaas-icon-'+item}}"
              title="{{'LOGIN.AUTHENTICATION.' + item + '.ICON_TOOL_TIP' | uppercase | translate}}"></span>
                <label>{{'LOGIN.AUTHENTICATION.' + item + '.ICON_TEXT' | uppercase | translate}}</label>
            </div>
        </li>
    </ul>

    <ng-container *ngIf="!allowedMFA.length">
        <p>{{'LOGIN.AUTHENTICATION.NO_AUTHENTICATION_METHODS_FOUND' | translate}}</p>
    </ng-container>
    <div class="mat-error">{{errorMessage | translate}} </div>
</ng-container>

<!--custom-->
<div style="float: left; width: 100%">
    <div fxLayout="column" fxLayoutAlign="space-around left" class="mobile-input" style="margin-top: 10px;">
        <h2 role="heading" class="globus-text">Sie haben noch kein Kundenkonto?</h2>

        <a tabindex="0" class="secondary-button-globus" (keydown.enter)="_onClickRegisterGLO($event)" (click)="_onClickRegisterGLO($event)">
            Konto erstellen
        </a>
    </div>
</div>

<!--<a *ngIf="showText" [routerLink]="" (click)="backClick()">{{'BACK' | translate}}</a>-->
